module.exports = __webpack_public_path__ + "img/SUPPORT.f19975ad.svg";